import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getContactCases } from 'services/ContactService'
import { Paging } from 'types/types'

export const useContactCasesQuery = (paging?: Paging) => {
  return useQuery({
    queryKey: reactQueryKeys.contactCases(paging),
    queryFn: () =>
      getContactCases({
        paging,
      }),
  })
}
